import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap-icons/font/bootstrap-icons.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/IRANSansWeb_Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"}],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"iranSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ClientScripts.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.scss");
